import { render, staticRenderFns } from "./query-nbn-appointment.vue?vue&type=template&id=39d4a79a&scoped=true"
import script from "./query-nbn-appointment.vue?vue&type=script&lang=js"
export * from "./query-nbn-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4a79a",
  null
  
)

export default component.exports